import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate financial and ledger queries across the application.
 * Call after recording payments, generating monthly bills, or reconciling bank statements.
 */
export function invalidateFinancialQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['expenses'] });
  queryClient.invalidateQueries({ queryKey: ['expenses-summary'] });
  queryClient.invalidateQueries({ queryKey: ['transactions'] });
  queryClient.invalidateQueries({ queryKey: ['transactions-credits'] });
  queryClient.invalidateQueries({ queryKey: ['transactions-month'] });
  queryClient.invalidateQueries({ queryKey: ['expenses-draft-summary'] });
  queryClient.invalidateQueries({ queryKey: ['expense_breakdown'] });
  queryClient.invalidateQueries({ queryKey: ['expenses-breakdown'] });
  queryClient.invalidateQueries({ queryKey: ['unit-ledger'] });
  queryClient.invalidateQueries({ queryKey: ['debtors-aging'] });
  queryClient.invalidateQueries({ queryKey: ['issue-status'] });
  queryClient.invalidateQueries({ queryKey: ['ledger-fund'] });
  queryClient.invalidateQueries({ queryKey: ['payments-register'] });
  queryClient.invalidateQueries({ queryKey: ['bank-transactions'] });
  queryClient.invalidateQueries({ queryKey: ['bank-imports'] });
  queryClient.invalidateQueries({ queryKey: ['bank-txs'] });
  queryClient.invalidateQueries({ queryKey: ['portal-unit-ledger'] });
  queryClient.invalidateQueries({ queryKey: ['portal-my-units'] });

  queryClient.invalidateQueries({ queryKey: ['recurring-bills'] });
  queryClient.invalidateQueries({ queryKey: ['dashboard-financials'] });
}

/**
 * Invalidate property, units, and roster queries.
 */
export function invalidatePropertyQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['properties'] });
  queryClient.invalidateQueries({ queryKey: ['property'] });
  queryClient.invalidateQueries({ queryKey: ['units'] });
  queryClient.invalidateQueries({ queryKey: ['property-units'] });
  queryClient.invalidateQueries({ queryKey: ['units-without-owner'] });
  queryClient.invalidateQueries({ queryKey: ['debtors-aging'] });
  queryClient.invalidateQueries({ queryKey: ['action-center'] });
}

/**
 * Invalidate maintenance ticketing queries.
 */
export function invalidateMaintenanceQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['maintenance-tickets'] });
  queryClient.invalidateQueries({ queryKey: ['maintenance-stats'] });
}

/**
 * Invalidate resident directory queries.
 */
export function invalidateResidentQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['residents'] });
  queryClient.invalidateQueries({ queryKey: ['property-residents'] });
  queryClient.invalidateQueries({ queryKey: ['units'] });
  queryClient.invalidateQueries({ queryKey: ['property-units'] });
  queryClient.invalidateQueries({ queryKey: ['units-without-owner'] });
  queryClient.invalidateQueries({ queryKey: ['debtors-aging'] });
  queryClient.invalidateQueries({ queryKey: ['action-center'] });
}

/**
 * Invalidate all queries on active property change.
 */
export function invalidateAllQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries();
}
